import { Tabs } from 'antd' 
import React from 'react' 
import PadContainer from '../../../components/PadContainer'
import AllSubsTab from './subscriptions';
import AdsSubTab from './ads';
import BusinessSubTab from './business';
import InsuranceSubTab from './insurance';

function SubscriptionsManagementPage() {

  const items = [
    {
      key: '1',
      label: 'All Subscription',
      children: <AllSubsTab />,
    },
    {
      key: '2',
      label: 'Ads Subscription',
      children: <AdsSubTab />,
    },
    {
      key: '3',
      label: 'Business Subscription',
      children: <BusinessSubTab />,
    },
    {
      key: '4',
      label: 'Insurance Subscription',
      children: <InsuranceSubTab />,
    },
  ];
  return (
    <PadContainer className="space-y-1">
      <div className='w-full bg-white rounded-lg border border-[#E4E7EC]'>
        <Tabs defaultActiveKey="1" type='card' size='large' items={items} />
      </div>
    </PadContainer>
  )
}

export default SubscriptionsManagementPage